import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaArrowRight } from "react-icons/fa6";
import "./NewsLetter.css";

const MEDIA_CARDS_DATA = [
  {
    id: "blogs",
    category: "01 / ENGINEERING & R&D",
    title: "Technical Blogs & Innovations",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80",
    description:
      "In-depth technical articles on green concrete formulations, 4D BIM infrastructure modeling, and sustainable urbanization trends.",
    tags: ["#GreenBuilding", "#4DBIMTech", "#PreFabConcrete"],
    highlight: "Engineering",
    path: "/blogs",
    buttonText: "EXPLORE BLOGS",
  },
  {
    id: "social-wall",
    category: "02 / VIP & DIGNITARIES",
    title: "Social Wall of Fame & VIPs",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
    description:
      "Celebrity endorsements from Suniel Shetty, ministerial visits from Union Ministers, international buyer delegations, and expo highlights.",
    tags: ["#SunielShetty", "#MakeInIndia", "#VIPDelegates"],
    highlight: "Celebrities",
    path: "/socialwalloffame",
    buttonText: "EXPLORE WALL OF FAME",
  },
  {
    id: "news-articles",
    category: "03 / PRESS & ARCHIVES",
    title: "News Articles & Press Releases",
    image:
      "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&w=1200&q=80",
    description:
      "Official press releases, national news headlines, major expressway tender wins, Morbi ceramic cluster milestones, and trade reports.",
    tags: ["#NationalPress", "#TenderAwards", "#InfraDaily"],
    highlight: "Press News",
    path: "/newsarticles",
    buttonText: "VIEW NEWS ARTICLES",
  },
  {
    id: "digital-media",
    category: "04 / VIDEO & BROADCAST",
    title: "Digital Media & Broadcasts",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
    description:
      "Exclusive CNBC TV18 broadcast interviews, 4K mega bridge construction walkthroughs, panel discussions, and digital video features.",
    tags: ["#CNBCTV18", "#4KDocumentary", "#LiveInterviews"],
    highlight: "Broadcasts",
    path: "/digitalmediacoverage",
    buttonText: "WATCH DIGITAL MEDIA",
  },
];

const NewsLetter = () => {
  const navigate = useNavigate();

  return (
    <div className="newsletter-page">
      <Helmet>
        <title>Newsletters & Media Showcase | Bharat Buildcon</title>
        <meta
          name="description"
          content="Explore Bharat Buildcon's newsletters, technical blogs, VIP social wall, press releases, and digital video broadcasts."
        />
      </Helmet>

      {/* Soft Ambient Background Elements */}
      <div className="slider-ambient-glow"></div>
      <div className="slider-ambient-glow-secondary"></div>

      <div className="newsletter-main-container">
        {/* ==================== HEADER SECTION ==================== */}
        <section className="newsletter-header-container">
          <div className="clean-breadcrumb-wrapper">
            <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
              <Link to="/" className="bc-home-link">
                HOME
              </Link>
              <span className="bc-slash">/</span>
              <span className="bc-active-page">NEWSLETTERS</span>
            </nav>
          </div>

          <h1 className="newsletter-hero-title">
            NEWSLETTERS &amp; <span className="gradient-text">MEDIA SHOWCASE</span>
          </h1>

          <p className="newsletter-hero-subtitle">
            Discover technical blogs, celebrity and ministerial spotlights,
            national press coverage, and broadcast documentaries driving India's
            $1.4 Trillion infrastructure journey.
          </p>
        </section>

        {/* ==================== CARD TYPE GRID LAYOUT ==================== */}
        <section className="newsletter-grid-section" aria-label="Media Showcase Channels">
          <div className="newsletter-cards-grid">
            {MEDIA_CARDS_DATA.map((card) => (
              <div key={card.id} className="newsletter-card-slot">
                <article
                  className="newsletter-card"
                  onClick={() => navigate(card.path)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      navigate(card.path);
                    }
                  }}
                >
                  {/* Media Image Thumbnail */}
                  <div className="card-media-wrapper">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="card-media-img"
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80";
                      }}
                    />
                  </div>

                  {/* Card Content Body */}
                  <div className="card-body">
                    <h2 className="card-title">{card.title}</h2>

                    <p className="card-description">{card.description}</p>

                    {/* Tags Row */}
                    <div className="card-tags-row">
                      {card.tags.map((tag, idx) => (
                        <span key={idx} className="card-tag-chip">
                          {tag}
                        </span>
                      ))}
                    </div>

                    {/* Card Bottom CTA Bar */}
                    <div className="card-footer">
                      <div
                        className="card-cta-btn"
                        aria-label={`${card.buttonText} - ${card.title}`}
                      >
                        <span>{card.buttonText}</span>
                        <FaArrowRight className="cta-arrow" />
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default NewsLetter;
